<template lang="">
	<div>
    <button @click="closeForm">
      <img style="width: 40px" src="../../../../static/images/close-grey.svg" />
    </button>
    <ValidationObserver v-slot="{ invalid }">
      <v-card class="mt-8 mx-8">

        <div width="550" class="d-flex flex-column px-8 py-8">
          <div class="d-flex flex-column mr-8 mt-8">
              <label class="font-weight-black">Usuário</label>
              <input
                readonly
                v-model="groupAssignment.name"
                type="text"
                class="inputCommunication mt-3"
                name="nome"
              >

          </div>
          <div class="d-flex flex-column mr-8 mt-8">
            <label class="font-weight-black">Grupos</label>
            <ValidationProvider
              class="form-group"
              rules="required"
            >
              <v-select multiple @input="setSelected" v-on:option:deselected="removeGroup" :value="usersGroupsList" class="inputCommunication mt-3" :options="filteredList" label="group_name"></v-select>
            </ValidationProvider>
          </div>
        </div>
      </v-card>
      <v-btn
        class="mt-4 ml-8 white--text"
        height="62"
        width="95"
        color="var(--red)"
        disabled = "true"
        :disabled="invalid"
        @click="onSubmit"
        
      >
       <div v-if="loadingData">
         <clip-loader
              v-if="loadingData"
              color="var(--white)"
              size="22px"
            />
       </div>
       <div v-if="!loadingData">Concluir</div>
      </v-btn>
      </ValidationObserver>
	</div>
</template>
<script>
// Lib
import { mapActions, mapState, mapMutations } from 'vuex'
import { ValidationProvider, ValidationObserver } from 'vee-validate'

import toaster from '../../../mixins/toaster.js'
import ClipLoader from "vue-spinner/src/ClipLoader.vue";

import VueCookies from 'vue-cookies'

export default {
  mixins: [
    toaster
  ],
  components: {
    ValidationProvider,
    ValidationObserver,
    ClipLoader,
  },
  data() {
    return {
      disabled: false,
      loadingData: false,
    }
  },
  computed: {
    ...mapState('MessageForm', [
      'smsLists',
    ]),
    ...mapState('UserManagement', [
      'groupAssignment',
      'usersGroupsList',
      'newGroups',
    ]),
    ...mapState('UserManagement', {
      userGroupsLists: 'usersGroupsList',
    }),
    filteredList() {
      const userListsId = this.usersGroupsList.map((smsList) => smsList.group_id)
      const availableLists = this.smsLists.filter(smsList => !userListsId.includes(smsList.id))
      return availableLists
    }
  },
  methods: {
    ...mapActions('MessageForm', [
      'getGroups',
      'getSmsLists',
      'postSmsList',
    ]),
    ...mapActions('UserManagement', [
      'postListFromUser',
      'deleteListFromUser',
      'getListFromUser'
    ]),
    ...mapMutations('UserManagement', {
      userAdd: 'SET_USER_GROUPS',
      setNewGroup: 'SET_USER_NEW_GROUPS',
    }),
    async onSubmit() {
      if (this.newGroups) {
        this.newGroups.forEach(this.postGroup)
      } else {
        this.closeForm()
      }
    },
    async removeGroup(group) {
      const token = VueCookies.get('jwt-login')
      if (group.group_id != null) {
        await this.deleteListFromUser({
          id_group: group.group_id,
          acta_user_id: this.groupAssignment.acta_user_id,
          token
        })
      }
    },
    async postGroup(group_id) {
      const token = VueCookies.get('jwt-login')
      this.loadingData = true
      await this.postListFromUser({
        id_group: group_id,
        acta_user_id: this.groupAssignment.acta_user_id,
        token
      })
      await this.getListFromUser({
        acta_user_id: this.groupAssignment.acta_user_id,
        token
      })
      this.loadingData = false;
    },
    setSelected(value) {
      this.userAdd(value)
      this.setNewGroup(value.map((item) => item.id).filter(item => item))
    },

    toaster(message, color, visible) {
      this.setToaster({
        message,
        color,
        visible
      })
    },
    closeForm() {
      this.$emit('close')
    }
  },
}
</script>
<style lang="scss" scoped>
.vs__dropdown-toggle {
  padding-top: 7px
}

.inputCommunication {
  border: 2px solid var(--grey-day-030);
  border-radius: 4px;
  width: 475px !important;
  min-height: 48px;
  padding: 15px;
  background: transparent;
  font-family: var(--dm-sans-regular);
  color: var(--grey);
}

.v-overlay__scrim {
  height: 200%
}

.textareaEdit {
  width: 475px;
  border: 2px solid var(--grey-day-030);
}
</style>


// WEBPACK FOOTER //
// src/components/Contents/ScheduleWeb/ListManagementEdit.vue